import '../../../core/components/app-root/AppRoot.css';
import './Overlay.css';
export var handleContainer = '_15qr1eq2-3-8-0';
export var overlay = '_15qr1eq0-3-8-0';
export var overlayContent = '_15qr1eq1-3-8-0';
export var resizeHandle = '_15qr1eq3-3-8-0';